import {
  SUBSCRIPTION_PLAN_ADVANCED,
  SUBSCRIPTION_PLAN_ELITE,
  SUBSCRIPTION_PLAN_INFINITY,
  SUBSCRIPTION_PLAN_ONBOARDING,
  SUBSCRIPTION_PLAN_PREMIUM
} from '@/constants/subscriptionPlans.js'
import { ROLE_COMPANY_RIDER } from '@/constants/userRoles.js'
import getRoleIsCompanyRole from '@/helpers/getRoleIsCompanyRole.js'
import { SET_PARTIAL_SUBSCRIPTION_DATA, SET_SUBSCRIPTIONS } from '@/store/mutationTypes.js'

const state = () => ({
  subscriptions: []
})

const getters = {
  districtsIsAvailable: (state, getters, rootState, rootGetters) => {
    return true
  },
  companyHasFreePlan: (state, getters, rootState, rootGetters) => {
    const someMainSubscriptionIsActivated = getters.companyHasOnboardingPlan || getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan
    return !state.subscriptions.length || !someMainSubscriptionIsActivated
  },
  companyHasInfinityPlan: (state, getters, rootState, rootGetters) => {
    if (!state.subscriptions.length) return false
    return state.subscriptions.includes(SUBSCRIPTION_PLAN_INFINITY)
  },
  companyHasElitePlan: (state, getters, rootState, rootGetters) => {
    if (!state.subscriptions.length) return false
    return state.subscriptions.includes(SUBSCRIPTION_PLAN_ELITE)
  },
  companyHasOnboardingPlan: (state, getters, rootState, rootGetters) => {
    if (!state.subscriptions.length) return false
    return state.subscriptions.includes(SUBSCRIPTION_PLAN_ONBOARDING)
  },
  companyHasAdvancedPlan: (state, getters, rootState, rootGetters) => {
    if (!state.subscriptions.length) return false
    return state.subscriptions.includes(SUBSCRIPTION_PLAN_ADVANCED)
  },
  companyHasPremiumPlan: (state, getters, rootState, rootGetters) => {
    if (!state.subscriptions.length) return false
    return state.subscriptions.includes(SUBSCRIPTION_PLAN_PREMIUM)
  },
  chatbotIsEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  ifoodIntegrationRegisterIsEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  nnFoodIntegrationRegisterIsEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  rappiIntegrationRegisterIsEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  companyBranchesEnabled: (state, getters, rootState, rootGetters) => {
    const userRole = rootGetters['auth/userRole']
    if (userRole === ROLE_COMPANY_RIDER) { return false }
    return getRoleIsCompanyRole(userRole)
  },
  unlimitedLinksEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  googleRatingsEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  getReviewsEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  excelExportEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  statsPageEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  settingFacebookPixelEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  settingFacebookDomainValidationEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  settingGoogleTagManagerEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  settingGoogleAnalyticsEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  unlimitedUsersEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  },
  showUpgradeYourPlan: (state, getters, rootState, rootGetters) => {
    // commented temporarily, requested by @morgan
    // if (rootGetters['flutter/panelIsEmbedInFlutter']) { return false }
    // if (rootGetters['flutter/panelIsInIosMobile']) { return false }
    if (rootGetters['auth/userRoleIsCompanyRider']) { return false }
    return rootGetters['auth/userHasCompanyRol']
  },
  editLandingStylesEnabled: (state, getters, rootState, rootGetters) => {
    return getters.companyHasAdvancedPlan || getters.companyHasPremiumPlan || getters.companyHasOnboardingPlan || getters.companyHasElitePlan || getters.companyHasInfinityPlan
  }
}

const actions = {
  setSubscriptions ({ commit }, { subscriptions }) {
    commit(SET_SUBSCRIPTIONS, { subscriptions })
  },
  setPartialSubscriptionData ({ commit }, { subscriptionId, data }) {
    commit(SET_PARTIAL_SUBSCRIPTION_DATA, { subscriptionId, data })
  }
}

const mutations = {
  [SET_SUBSCRIPTIONS] (state, { subscriptions }) {
    state.subscriptions = subscriptions
  },
  [SET_PARTIAL_SUBSCRIPTION_DATA] (state, { subscriptionId, data }) {
    const subscription = state.subscriptions.find(item => item.id === subscriptionId)

    if (!subscription) { return }

    for (const [key, value] of Object.entries(data)) {
      subscription[key] = value
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
